import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class SubscriptionPlanModel extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true },
            name: {},
            member_rates: {},
            cycle_end_date: {},
            max_duration_days: {},
            renewal_config: {}
        };
    }

    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][SubscriptionPlanModel] organizationId is mandatory');
        }
        return `/ticket/organizations/${organizationId}/subscription-plans`;
    }
}
